import apiurl from './apiurl';
import axios from 'axios';

const empresas = {
    getEmpresas: async (idToken) =>
        axios({
            'method': 'GET',
            'url': apiurl + 'empresas',
            'headers': {
                'content-type': 'application/json',
                'Authorization': "Bearer " + idToken
            },
            'crossdomain': true,
        }),

    getEmpresa: async (tenant_id, idToken) =>
        axios({
            method: 'GET',
            url: apiurl + 'empresas/' + encodeURIComponent(tenant_id),
            headers: {
                'content-type': 'application/json',
                'Authorization': "Bearer " + idToken
            },
            crossdomain: true,
        }),

    createEmpresa: async (body, idToken) =>
        axios({
            method: 'POST',
            url: apiurl + 'empresas',
            headers: {
                'content-type': 'application/json',
                'Authorization': "Bearer " + idToken
            },
            data: body,
            crossdomain: true,
        }),

    getDeviceRegistrationKey: async (tenant_id, idToken) =>
        axios({
            method: 'GET',
            url: apiurl + 'empresas/' + encodeURIComponent(tenant_id) + '/deviceregistrationkey',
            headers: {
                'content-type': 'application/json',
                'Authorization': "Bearer " + idToken
            },
            crossdomain: true,
        }),

    updateEmpresa: async (tenant_id, body, idToken) =>
        axios({
            method: 'PUT',
            url: apiurl + 'empresas/' + encodeURIComponent(tenant_id),
            headers: {
                'content-type': 'application/json',
                'Authorization': "Bearer " + idToken
            },
            data: body,
            crossdomain: true,
        }),

    getDeviceConfigGroups: async (tenant_id, idToken) =>
        axios({
            method: 'GET',
            url: apiurl + 'empresas/' + encodeURIComponent(tenant_id) + '/deviceconfiggroup',
            headers: {
                'content-type': 'application/json',
                'Authorization': "Bearer " + idToken
            },
            crossdomain: true,
        }),

    getDeviceConfigGroup: async (tenant_id, deviceconfiggroup_id, idToken) =>
        axios({
            method: 'GET',
            url: apiurl + 'empresas/' + encodeURIComponent(tenant_id) + '/deviceconfiggroup/' + encodeURIComponent(deviceconfiggroup_id),
            headers: {
                'content-type': 'application/json',
                'Authorization': "Bearer " + idToken
            },
            crossdomain: true,
        }),

    createDeviceConfigGroup: async (tenant_id, body, idToken) =>
        axios({
            method: 'POST',
            url: apiurl + 'empresas/' + encodeURIComponent(tenant_id) + '/deviceconfiggroup',
            headers: {
                'content-type': 'application/json',
                'Authorization': "Bearer " + idToken
            },
            data: body,
            crossdomain: true,
        }),

    updateDeviceConfigGroup: async (tenant_id, id, body, idToken) =>
        axios({
            method: 'PUT',
            url: apiurl + 'empresas/' + encodeURIComponent(tenant_id) + '/deviceconfiggroup/' + encodeURIComponent(id),
            headers: {
                'content-type': 'application/json',
                'Authorization': "Bearer " + idToken
            },
            data: body,
            crossdomain: true,
        }),

    deleteDeviceConfigGroup: async (tenant_id, id, idToken) =>
        axios({
            method: 'DELETE',
            url: apiurl + 'empresas/' + encodeURIComponent(tenant_id) + '/deviceconfiggroup/' + encodeURIComponent(id),
            headers: {
                'content-type': 'application/json',
                'Authorization': "Bearer " + idToken
            },
            crossdomain: true,
        }),

    updateEmpresaStatus: async (tenant_id, status, idToken) =>
        axios({
            method: 'PATCH',
            url: apiurl + 'empresas/' + encodeURIComponent(tenant_id) + '/status',
            headers: {
                'content-type': 'application/json',
                'Authorization': "Bearer " + idToken
            },
            data: { status },
            crossdomain: true,
        })

};

export default empresas;
